import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link as RouterLink } from 'react-router-dom';
import { useMutation } from 'react-query';

export default function ListPlans() {
    const [plans, setplans] = useState(null);
    const { isLoading: isLoadingplans, refetch: getplans } = useQuery(
        "investment-plans",
        async () => {
          return await apiClient.get("/api/investment-plans");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setplans(res.data.plans);
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );
    
      const { mutate: deletePlan } = useMutation(
        async (planId) => {
          return await apiClient.delete(`/api/delete-plan/${planId}`);
        },
        {
          onSuccess: (res) => {
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            getplans(); // Refresh the list
          },
          onError: (err) => {   
            let myerror = err.response?.data || err;         
            localStorage.setItem('notification', JSON.stringify({message : `Error: ${myerror.message || 'Failed to delete plan'}`, 'type': 'error' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
          },
        }
      );

      const handleDelete = (planId, planName) => {
        if (window.confirm(`Are you sure you want to delete "${planName}"? This action cannot be undone.`)) {
          deletePlan(planId);
        }
      };

      useEffect(() => {
        getplans() 
        if (isLoadingplans) {
            const event3 = new Event('processing');
            window.dispatchEvent(event3);
        }
      }, []);

  const getDate = (date) => new Date(date).toDateString();
  return (
    <div style={{marginTop: '75px'}}>
    <Container>
        <Typography  mt={4} mb={2} sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', textTransform: 'uppercase' }} gutterBottom variant="h6" component="div">
        
        {isLoadingplans? 'Loading Plans...' : 'List of Investment Suites'}
      </Typography>
    <TableContainer component={Paper}>
        
      {plans !== null &&
      <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
        <TableCell>Investment Suite Name</TableCell>
          <TableCell align="right">Investment Type</TableCell>
          <TableCell align="right">Min Amount ($)</TableCell>
          <TableCell align="right">Max Amount ($)</TableCell>
          <TableCell align="right">Return Range (%)</TableCell>
          <TableCell align="right">Duration Range</TableCell>
          <TableCell align="right">Actions</TableCell>
          <TableCell align="right">Created Date</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {plans.map((plan) => (
          <TableRow
            key={plan.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell component="th" scope="row">
            {plan.name}
            </TableCell>
            <TableCell align="right">{plan.investment_type || 'N/A'}</TableCell>
            <TableCell align="right">${plan.min_amount?.toLocaleString() || 'N/A'}</TableCell>
            <TableCell align="right">${plan.amount_invested?.toLocaleString() || 'N/A'}</TableCell>
            <TableCell align="right">
              {plan.min_return_percentage && plan.max_return_percentage 
                ? `${plan.min_return_percentage}% - ${plan.max_return_percentage}%` 
                : `${plan.total_earning || 'N/A'}%`}
            </TableCell>
            <TableCell align="right">{plan.investment_duration_range || plan.duration || 'N/A'}</TableCell>
            <TableCell align="right">
              <Button 
                component={RouterLink} 
                to={`/edit-plan/${plan.id}`} 
                startIcon={<EditIcon />}
                size="small"
                sx={{ mr: 1 }}
              >
                Edit
              </Button>
              <Button 
                onClick={() => handleDelete(plan.id, plan.name)}
                startIcon={<DeleteIcon />}
                color="error"
                size="small"
              >
                Delete
              </Button>
            </TableCell>
            <TableCell align="right">{getDate(plan.created_at)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
      }
      
    </TableContainer>
    </Container>
    </div>
  );
}